module.exports = __webpack_public_path__ + "img/alert-circle-outline.a5d5662c.svg";